export const getApiErrorMessage = (error, fallback = "Something went wrong") => {
  const apiError = error?.response?.data || error;

  if (Array.isArray(apiError?.data?.errors) && apiError.data.errors.length > 0) {
    return apiError.data.errors.join(" ");
  }

  if (Array.isArray(apiError?.errors) && apiError.errors.length > 0) {
    return apiError.errors.join(" ");
  }

  if (apiError?.message) {
    return apiError.message;
  }

  if (typeof apiError === "string") {
    return apiError;
  }

  return fallback;
};
